import IConfig from '~interfaces/config';
import getConfig from 'next/config';
const nextConfig = getConfig();

const env =
  nextConfig &&
  nextConfig.publicRuntimeConfig &&
  nextConfig.publicRuntimeConfig.ENV
    ? nextConfig.publicRuntimeConfig.ENV
    : process.env.ENV || 'local';
// const env = 'development';
const config: IConfig = {
  local: {
    BASE_PATH_PREFIX: '/servicii-fixe',
    DOTCMS_HOST: 'https://api-cms-dev.aws.connex.ro',
    DOTCMS_HOSTID: 'c218c1ae-4760-42a5-bcf0-d172ca22a0ca',
    // tslint:disable-next-line:max-line-length
    DOTCMS_API_TOKEN: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGljM2M3MDAwZC0wOTc2LTQ1ZWUtYWM0Mi03ZTQ0ZTNiODZiYjMiLCJ4bW9kIjoxNjE3MjY0NjAzMDAwLCJuYmYiOjE2MTcyNjQ2MDMsImlzcyI6ImRldi1nNTIzZmtkNGNvIiwibGFiZWwiOiJ2b2RhZm9uZS5ybyIsImV4cCI6MTcxMTkxODgwMiwiaWF0IjoxNjE3MjY0NjAzLCJqdGkiOiJmZTUxZWEwYS1lM2ZkLTQxOTctODgwYi1iYWZlNzUyOWJlMTgifQ.qO-aeVplymJPml2ymdjkJJSjj7p42IC4VqwMMasP3Ec',
    PUBLIC_URL: 'https://servicii-fixe-dev.aws.connex.ro',
    RECAPTCHA_SITE_KEY: '6LeolsUUAAAAANRgNro7FlnKmTAXOKxQgMTXLDSy',
    filters: {
      brandFilterName: 'mfg',
    },
  },
  development: {
    BASE_PATH_PREFIX: '/servicii-fixe',
    DOTCMS_HOST: 'https://api-cms-dev.aws.connex.ro',
    DOTCMS_HOSTID: 'c218c1ae-4760-42a5-bcf0-d172ca22a0ca',
    DOTCMS_API_TOKEN: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGljM2M3MDAwZC0wOTc2LTQ1ZWUtYWM0Mi03ZTQ0ZTNiODZiYjMiLCJ4bW9kIjoxNjE3MjY0NjAzMDAwLCJuYmYiOjE2MTcyNjQ2MDMsImlzcyI6ImRldi1nNTIzZmtkNGNvIiwibGFiZWwiOiJ2b2RhZm9uZS5ybyIsImV4cCI6MTcxMTkxODgwMiwiaWF0IjoxNjE3MjY0NjAzLCJqdGkiOiJmZTUxZWEwYS1lM2ZkLTQxOTctODgwYi1iYWZlNzUyOWJlMTgifQ.qO-aeVplymJPml2ymdjkJJSjj7p42IC4VqwMMasP3Ec',
    PUBLIC_URL: 'https://dxp-dev.aws.connex.ro/servicii-fixe',
    RECAPTCHA_SITE_KEY: '6LeolsUUAAAAANRgNro7FlnKmTAXOKxQgMTXLDSy',
  },
  pet: {
    BASE_PATH_PREFIX: '/servicii-fixe',
    DOTCMS_HOST: 'https://api-cms.vfro.net/',
    DOTCMS_HOSTID: 'c218c1ae-4760-42a5-bcf0-d172ca22a0ca',
    DOTCMS_API_TOKEN:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGkyOGMyNTc1OS0xNjM2LTQ2YmItYWQwZC04NTc4MzE2ZjgxNjEiLCJ4bW9kIjoxNTk5MDM4OTIxMDAwLCJuYmYiOjE1OTkwMzg5MjEsImlzcyI6InBldC1nZTQxNDQ4N2FhIiwibGFiZWwiOiJTRVJWSUNJSS1QRVQiLCJleHAiOjE2OTM2MDIwMDEsImlhdCI6MTU5OTAzODkyMSwianRpIjoiOGRjNTdmYTAtYWFlNS00ZjJjLTkzMzQtYTg4M2VjMjVlMTMyIn0.enWm3zx6ynN8A7vEa_e7CkHJCodRkrEKse4Qe4EB1RI',
    PUBLIC_URL: 'https://www.vfro.net/servicii-fixe',
    TEALIUM_ENV: 'pet',
    RECAPTCHA_SITE_KEY: '6LeolsUUAAAAANRgNro7FlnKmTAXOKxQgMTXLDSy',
  },
  uat: {
    BASE_PATH_PREFIX: '/servicii-fixe',
    DOTCMS_HOST: 'https://api-cms-uat.aws.connex.ro',
    DOTCMS_HOSTID: 'c218c1ae-4760-42a5-bcf0-d172ca22a0ca',
    DOTCMS_API_TOKEN:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGliYjI4NWQ5MS05NTUzLTRmY2UtOWZkMi00ZGYwNWYwYjE0MTQiLCJ4bW9kIjoxNjE1OTc1Nzc4MDAwLCJuYmYiOjE2MTU5NzU3NzgsImlzcyI6InVhdC1oNWN1MjR5cW02IiwibGFiZWwiOiJzZXJ2aWNpaS1maXhlIiwiZXhwIjoxNzEwNjI2NDAxLCJpYXQiOjE2MTU5NzU3NzgsImp0aSI6ImUwYzNhNTY5LWZlY2YtNDg4OS05NmNjLTQ0MDM4YWYwNTlmYiJ9.wt-TB3y41iD2jNe7QM553fa8KXIrk-f2ri8BIDmkIRs',
    PUBLIC_URL: 'https://dxp-uat.aws.connex.ro',
    TEALIUM_ENV: 'dev',
    RECAPTCHA_SITE_KEY: '6LeolsUUAAAAANRgNro7FlnKmTAXOKxQgMTXLDSy',
    filters: {
      brandFilterName: 'mfg',
    },
  },
  production: {
    BASE_PATH_PREFIX: '/servicii-fixe',
    DOTCMS_HOST: 'https://api-cms.vodafone.ro',
    DOTCMS_HOSTID: 'c218c1ae-4760-42a5-bcf0-d172ca22a0ca',
    DOTCMS_API_TOKEN:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGkwMjJlNzEzOS1jN2I3LTQ3MzctYTk4YS00ZTE1Yzk5OGVjZDQiLCJ4bW9kIjoxNTk2MDYwODI2MDAwLCJuYmYiOjE1OTYwNjA4MjYsImlzcyI6InByb2QtaDY4MWZiYjgyYSIsImxhYmVsIjoidm9kYWZvbmUtcm8iLCJleHAiOjE3NTM5MDkyMDAsImlhdCI6MTU5NjA2MDgyNiwianRpIjoiOTA0YzQwYjItNjk3Yy00ZWQ3LTlkMzAtOTI4YmQyOWZmOTMzIn0.0EDRrzi-TWl3fYVcNSQHKVGKilDvA3utoIB-p26D7zA',
    PUBLIC_URL: 'https://www.vodafone.ro',
    TEALIUM_ENV: 'prod',
    RECAPTCHA_SITE_KEY: '6Lc4qMUUAAAAAPplv-AFKamQglwVuWzPH47sR63u',
    filters: {
      brandFilterName: 'mfg',
    },
  },
};
export const breakpoints: any = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export default config[env];
